import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import Loader from "../../ui/Loader";
import { BodyBuilder } from "../../../exports/Images";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { deleteWorkoutGoal } from "../../../data/ApiEndpoints";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import GoalForm from "./GoalForm";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";

const AllGoals = ({
  isPage,
  setIsPage,
  callFunction,
  userInfoData,
  modValues,
  setModValues,
  onCloseModalvalues,
}) => {
  const dispatch = useDispatch();
  const { loading, workoutGoalData } = useSelector((state) => state.webApi);

  const { data, pagination } = workoutGoalData || {};
  const { isModOpen, cardName } = modValues || {};

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: deleteWorkoutGoal,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "name",
      text: "name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
      },
    },
    {
      dataField: "image",
      text: "image",
      formatter: (cell, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.image || BodyBuilder}
              alt={row?.name || "NA"}
              className="image"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  viewImage: row?.image || BodyBuilder,
                  cardName: "image",
                }))
              }
            />
          </div>
        );
      },
    },
    {
      dataField: "description",
      text: "description",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {/* {row?.description || "NA"} */}

            {row.description?.length <= 20 ? (
              row.description
            ) : row.description?.length >= 20 ? (
              <>
                {row.description?.substring(0, 20)}
                <b
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardName: "description",
                      description: row.description,
                    }))
                  }
                >
                  ...Read More
                </b>
              </>
            ) : (
              "NA"
            )}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "edit",
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash3-fill"
                viewBox="0 0 16 16"
              >
                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
              </svg>
            )}
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={isModOpen}
        onRequestClose={onCloseModalvalues}
        contentLabel="Workout Goal Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer mod-width-50p`}
          style={{
            width:
              cardName === "image" || cardName === "description" ? "auto" : "",
            height:
              cardName === "image" || cardName === "description" ? "auto" : "",
          }}
        >
          {cardName !== "add" && cardName !== "edit" ? (
            <ModalHeadAndClose
              title={`${cardName?.replace(/_/g, " ")}`}
              onClose={onCloseModalvalues}
            />
          ) : null}

          {cardName === "add" || cardName === "edit" ? (
            <GoalForm
              userInfoData={userInfoData}
              callFunction={callFunction}
              closeModal={onCloseModalvalues}
              isEdit={cardName === "edit"}
              rowData={modValues.rowData}
            />
          ) : cardName === "image" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={modValues.viewImage}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : cardName === "description" ? (
            <div className="discussionModalMessage mt30">
              <p className="message">
                {modValues.description || "No Content Available"}
              </p>
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={data?.length > 0 ? data : []}
            tableColumns={tbColumns}
            tablePagination={pagination?.length > 0 ? pagination : []}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>
    </>
  );
};

export default AllGoals;
